import { styled } from "@pigment-css/react";

interface SidePanelHeaderProps {
  title: string;
  subtitle: string;
  dateSelector?: React.ReactNode;
}

const HeaderWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: theme.managementView.spacing[16],
}));

const HeaderContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.managementView.spacing[4],
}));

const Title = styled("h2")(({ theme }) => ({
  fontFamily: theme.managementView.font.family,
  fontSize: theme.managementView.font.size[21],
  fontWeight: theme.managementView.font.weight[500],
  letterSpacing: theme.managementView.font.letterSpacing.tight,
  color: theme.managementView.colors.neutral[90],
  margin: 0,
}));

const Subtitle = styled("p")(({ theme }) => ({
  fontFamily: theme.managementView.font.family,
  fontSize: theme.managementView.font.size[16],
  fontWeight: theme.managementView.font.weight[400],
  color: theme.managementView.colors.neutral[56],
  margin: 0,
}));

const DateSelectorContainer = styled("div")({
  flexShrink: 0,
});

export const SidePanelHeader = ({ title, subtitle, dateSelector }: SidePanelHeaderProps) => {
  return (
    <HeaderWrapper>
      <HeaderContainer>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </HeaderContainer>
      {dateSelector && <DateSelectorContainer>{dateSelector}</DateSelectorContainer>}
    </HeaderWrapper>
  );
};
